// Components==============
import React from 'react';
import './Text.module.scss';
// =========================

export default function Text({ text }: { text: string }) {
  return <div dangerouslySetInnerHTML={{ __html: text }} styleName="text" />;
}
